/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import {style, animate, transition, state, trigger} from '@angular/animations';


export class Animations {
  static page = [
		trigger('routerTransition', [
    	state('void', style({position:'fixed', width:'100%'}) ),
    	state('*', style({position:'fixed', width:'100%'}) ),
    	transition(':enter', [  // before 2.1: transition('void => *', [
      	style({opacity:0}),
      	animate('0.4s ease-in-out', style({opacity:1}))
    	]),
    	transition(':leave', [  // before 2.1: transition('* => void', [
      	style({opacity:1}),
      	animate('0.2s ease-in-out', style({opacity:0}))
    	])
  	])
	];

  static authForms = [
    trigger('dropIn', [
      state('on', style({
        opacity: '1',
        transform: 'translateY(20px)'
      })),
      state('off', style({
        opacity: '0.1'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('600ms ease-in-out'))
    ])
  ];
}



// WEBPACK FOOTER //
// ./client/app/global/animations.ts